import { Location } from 'react-router-dom';

export const useSearchSourceLocation = (location: Location): string => {
  const from = location?.state?.from;

  if (from) {
    return from;
  }

  if (performance) {
    const navEntry = performance.getEntriesByType?.('navigation')?.[0] as
      | PerformanceNavigationTiming
      | undefined;
    if (navEntry && typeof navEntry.type === 'string') {
      return navEntry.type;
    } else if ('navigation' in performance) {
      const legacyNavigation = (performance as { navigation: { type: number } })
        .navigation;
      const legacyType = legacyNavigation.type;
      return legacyType === 1
        ? 'reload'
        : legacyType === 2
          ? 'back_forward'
          : 'navigate';
    }
  }

  return '';
};
